
import React from 'react';
import ReactDom from 'react-dom';
import {MetricSelector, QuickMetricSelector} from './selector';

if( document.getElementById('metric_material_variants') ){

    ReactDom.render( <MetricSelector/>, document.getElementById('metric_material_variants'));

}

let elements = document.querySelectorAll('.add-to-basket.quick');
elements.forEach( ( elem ) => {

    elem.addEventListener('click', ( e )=>{

        e.preventDefault();


        let overflow = document.createElement('div');
        overflow.className = 'dp-overflow';

        let contener = document.createElement('div');
        contener.className = 'quick-add-variant';

        let closer = document.createElement('div');
        closer.className = 'close-window';
        closer.addEventListener( 'click', close );

        contener.appendChild( closer );

        let appCont = document.createElement('div');
        overflow.appendChild( contener );
        contener.appendChild( appCont );

        document.body.appendChild( overflow );

        ReactDom.render( <QuickMetricSelector target={elem}/>, appCont );


        function close(){
            
            if( overflow.parentNode ){
                overflow.parentNode.removeChild( overflow );
            }

        }

    });

} );